import React, { Component, Fragment } from 'react';
import { reduxForm, Field } from 'redux-form';
import { Grid, Form } from 'semantic-ui-react';
import { withRouter } from 'react-router';
import { SelectField, TextAreaField } from 'Common/SemanticWrapper';

import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { IdCardsFieldEnum as Fields } from 'Common/FieldEnum';
import { ID_CARDS_FORM_NAME } from 'Common/FormEnum';
import {
  sortByOptions,
  uniqueIdentifierOptions,
  displayOptions,
} from '../Constants';
import CheckboxListComponent from 'Common/CheckboxListComponent';
import { SiteComponent } from 'Common/SiteComponent';
import { TitledCard } from 'Components/';

class IdCardsFormContainer extends Component {
  dropDownChange = data => {
    this.props.onSiteChange(data);
  };

  teacherOptions() {
    const results = this.props.teachers.map((teacher, i) => ({
      value: teacher,
      text: teacher,
      key: `${teacher}${i}`,
    }));
    return results;
  }

  render() {
    const { handleSubmit, onGradeChange, gradeOptions } = this.props;

    return (
      <Fragment>
        <Form onSubmit={handleSubmit} name={ID_CARDS_FORM_NAME}>
          <TitledCard title="Filter By">
            <Grid columns={1}>
              <Grid.Row>
                <Grid.Column width={8}>
                  <SiteComponent
                    name={Fields.Site}
                    onChange={this.dropDownChange}
                    {...this.props}
                    isForm={true}
                    isAllRequired={true}
                  />
                </Grid.Column>
                <Grid.Column width={8}>
                  <Field
                    name={Fields.Teacher}
                    component={SelectField}
                    type="text"
                    label="Teacher"
                    options={this.teacherOptions()}
                    loading={false}
                    disabled={false}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={8}>
                  <Field
                    multiple
                    name={Fields.Grade}
                    component={SelectField}
                    type="text"
                    label="Grade"
                    options={gradeOptions}
                    onChange={onGradeChange}
                    loading={false}
                    disabled={false}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column className="field" width={16}>
                  <label className={'p-b-0'}>meal status</label>
                </Grid.Column>
                <CheckboxListComponent
                  {...this.props}
                  title={''}
                  showAll={true}
                  displayItems={this.props.statusCheckboxes}
                />
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={8}>
                  <Field
                    name={Fields.SpecificStudents}
                    component={TextAreaField}
                    type="text"
                    label="Specific Students (Student Number(s), separated by a comma)"
                    maxLength={250}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </TitledCard>
          <TitledCard title="Sort by">
            <Grid columns={1}>
              <Grid.Column className="input-group--btn-group">
                <ReduxFormButtonGroup
                  label={''}
                  options={sortByOptions}
                  formName={ID_CARDS_FORM_NAME}
                  fieldName={Fields.SortBy}
                />
              </Grid.Column>
            </Grid>
          </TitledCard>
          <TitledCard title="Report Setting">
            <Grid columns={1}>
              <Grid.Row>
                <Grid.Column className="input-group--btn-group" width={8}>
                  <ReduxFormButtonGroup
                    label={'Unique Identifier'}
                    options={uniqueIdentifierOptions}
                    formName={ID_CARDS_FORM_NAME}
                    fieldName={Fields.UniqueIdentifier}
                  />
                </Grid.Column>
                <Grid.Column className="field" width={4}>
                  {/* prettier-ignore */}
                  <label className={'p-b-0'} style={{ whiteSpace: 'pre-wrap' }}>
                    id cards are formatted for 
                    avery&reg; 5371 business cards or
                    compatible cardstock
                  </label>
                </Grid.Column>
              </Grid.Row>
              <CheckboxListComponent
                {...this.props}
                showAll={false}
                title={'display on card'}
                displayItems={displayOptions}
              />
            </Grid>
          </TitledCard>
        </Form>
      </Fragment>
    );
  }
}

const validate = (values, props) => {
  const errors = {};
  return errors;
};

const IdCardsForm = reduxForm({
  validate,
  form: ID_CARDS_FORM_NAME,
  enableReinitialize: true,
})(withRouter(IdCardsFormContainer));

export { IdCardsForm };



// WEBPACK FOOTER //
// ./src/pages/idcards/components/IdCardsForm.js